import { AppContainer } from '@/components/AppContainer/AppContainer';
import styles from './NoTelegramPage.module.scss';
import { useState, useEffect } from 'react';
import { Loader } from '@/components/Loader/Loader';

export const DesktopPage = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return (
      <AppContainer>
        <Loader />
      </AppContainer>
    );
  }

  return (
    <AppContainer>
      <div className={styles.NoTelegramPage}>
        <h1 className={styles.NoTelegramPage__title}>
          Откройте в Telegram на телефоне
        </h1>
        <div className={styles.NoTelegramPage__qr}>
          <img
            className={styles.NoTelegramPage__qr__image}
            src="/qr.jpg"
            alt="qr"
          />
        </div>
        <p className={styles.NoTelegramPage__text}>
          Это приложение доступно только в Telegram на мобильных устройствах.
          Пожалуйста, откройте его через Telegram на телефоне, воспользовавшись
          QR-кодом выше, так же вы можете нажать на кнопку ниже.
        </p>
        <button
          className={styles.NoTelegramPage__button}
          onClick={() => (window.location.href = 'https://t.me/starsheikhbot')}
        >
          Открыть в Telegram
        </button>
      </div>
    </AppContainer>
  );
};
